/**
 * KONFIGURATOR ZGŁOSZEŃ — jedno wejście HTTP dla nowych endpointów obszaru /admin/categories.
 *
 * Dlaczego osobny plik, a nie dopisek w `api/apiService.js`: apiService jest wspólnym, ~2400-liniowym
 * słownikiem całej aplikacji — każdy równoległy etap prac dopisuje tam swoje metody i plik jest
 * najczęstszym miejscem konfliktów. Wzorzec z `pages/eteczka/eteczkaApi.js`: obszar trzyma własny
 * moduł, ale korzysta z TEJ SAMEJ instancji axiosa (`apiService.api`), więc nagłówek autoryzacji,
 * obsługa 401 i limity są identyczne — nie powstaje druga konfiguracja klienta.
 */
import apiService from "../../api/apiService";

const http = apiService.api;

const categoriesApi = {
    // ── [N3] Dlaczego okna nie widać w „Utwórz nowe zgłoszenie" ──
    /** Per okno: czy bieżący użytkownik je zobaczy, a jeśli nie — DLACZEGO. */
    widocznoscOkien: () => http.get("/categories/tile-visibility"),

    /** [polecenie właściciela 2026-09-19] Frazy słownika reguł do WYSZUKIWARKI okien w „Utwórz nowe
     *  zgłoszenie": `[{ categoryId, frazy: [...] }]` dla reguł AKTYWNYCH. Same napisy — bez nazw reguł,
     *  skrzynek i liczników; pełny słownik zostaje za `CategoryManagePolicy`. Dzięki temu „nie drukuje"
     *  znajduje okno „Drukarka / skaner", a nie tylko to, co człowiek i tak widzi na kafelku. */
    frazyWyszukiwania: () => http.get("/categories/frazy-wyszukiwania"),

    // ── [N6] Drzewo uprawnień modułów dynamicznych (klucze MOD.<KOD>.<AKCJA>) ──
    uprawnieniaModulow: () => http.get("/ticket-modules/permissions"),

    // ── [N10b] Usunięcie z obsady POJEDYNCZEJ osoby (agent desku) ──
    usunZObsady: (moduleId, userId) => http.delete(`/ticket-modules/${moduleId}/desk-agents/${userId}`),

    /** Dopisanie POJEDYNCZEJ osoby do obsady — panel miał dotąd wyłącznie usuwanie, więc
     *  jedynym sposobem dodania kogokolwiek było wciągnięcie do obsady całego działu. */
    dodajDoObsady: (moduleId, userId) => http.post(`/ticket-modules/${moduleId}/desk-agents`, { userId }),

    // ── [N7] Przypięcie skrzynki z /admin/integrations do modułu (obie strony naraz) ──
    /** `opcje.defaultCategoryId` — kategoria nadawana mailom BEZ korelacji z tej skrzynki (null = bez);
     *  `opcje.makeDefault` — czy to domyślna skrzynka działu realizującego (null = nie zmieniaj).
     *  Oba pola żyły dotąd wyłącznie w usuniętym modalu skrzynek w /admin/integrations. */
    przypnijSkrzynke: (moduleId, configurationId, opcje = {}) =>
        http.post(`/ticket-modules/${moduleId}/bind-mailbox`, {
            configurationId: configurationId || null,
            defaultCategoryId: opcje.defaultCategoryId || null,
            makeDefault: opcje.makeDefault ?? null,
        }),

    /** Odpięcie skrzynki od modułu: znika mapowanie skrzynki na dział i skrzynka wejściowa modułu. */
    odepnijSkrzynke: (moduleId) => http.delete(`/ticket-modules/${moduleId}/bind-mailbox`),
};

export default categoriesApi;
